import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
// import { OrderService } from 'api/order/order.service';

// import { ProductService } from 'api/product/product.service';
// import { UserdetailsService } from 'api/userdetails/userdetails.service';
// import { UserService } from 'api/user/user.service';
import { BlogPostdetailsService } from 'api/blogpostdetails/blogpostdetails.service';
import { BlogpostService } from 'api/blogpost/blogpost.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { BlogtagService } from 'api/blogtag/blogtag.service';
import { ApiConstant } from 'api/api.constant';




declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'application-page',
    templateUrl: './blogpostdetail.html',
})
export class Blogpostdetail implements OnInit {

    searchvalue: String;
    id: any;
    imageid: any
    file: File
    imagename: string
    blogimage = []
    index: number
    iname: any;
    blogdata = []
    title: any
    url: any
    category: any
    athumbnails: File = null
    athumbnails1: File
    sortdescription: any
    description: any
    imageurl: any
    status = "SAVEDRAFT"
    alltag = [];
    alltag1 = []
    selectedtag1 = []
    versionincrement = 0.1
    a: number;
    profilepic: any
    banner: File = null
    blogurl: any
    bid: any;
    version: any
    categoryId: any
    constructor(private router: Router,
        private blogpostdetailservice: BlogPostdetailsService,
        private blogpostService: BlogpostService,
        private blogtagService: BlogtagService,
        private activatedroute: ActivatedRoute,
        private apiservice: ApiConstant) {

    }

    ngOnInit() {

        this.getalltag();
        this.blogurl = this.apiservice.Server + "singleblog/"
        this.imageurl = this.apiservice.Server + "uploads/blogimage/"
        const params = this.activatedroute.snapshot.params;
        this.id = params.id
        this.bid = params.bid



        $(function () {
            $('.select4').select2();
            $('.select4-tags').select2({
                tags: true,
                tokenSeparators: [',', ' ']
            });
            $('.selectpicker').selectpicker();
        });

        $(function () {
            $('.summernote').summernote({
                height: 50
            });
        });
        $(function () {
            $('.summernote1').summernote({
                height: 500
            });
        });



        // this.resetData()
        this.blogpostService.allBlogpost(this.bid).then(data => {

            if (data) {
                // this.resetData()
                this.blogdata = data

                // for(let i=0;i<data.length;i++){
                //     if(data[i].id==this.id){
                //             this.blogdata.push(data[i])
                //     }

                // }


               
                this.title = this.blogdata[0]['title']



                this.category = this.blogdata[0]['category']
                this.categoryId = this.blogdata[0]['categoryId']
                this.url = this.blogdata[0]['url']
                //  this.url=this.blogdata[0]['url']

                this.sortdescription = this.blogdata[0]['sortdescription']
                // this.sortdescription = "";

                if (this.sortdescription != null) {

                    $('.summernote').siblings('.note-editor').children('.note-editing-area').children('div.note-editable').html("");
                    $('.summernote').siblings('.note-editor').children('.note-editing-area').children('div.note-editable').append(this.sortdescription);
                }
                this.description = this.blogdata[0]['description']
                if (this.description != null) {
                    $('.summernote1').siblings('.note-editor').children('.note-editing-area').children('div.note-editable').html("");
                    $('.summernote1').siblings('.note-editor').children('.note-editing-area').children('div.note-editable').append(this.description);
                }


                this.athumbnails = this.blogdata[0]['articlethumbnails']

                var str = this.blogdata[0]['tagId'];
             
                if (str != undefined) {


                    var arr = str.split(",");
                    var tagarr = [];


                    for (var j = 0; j < this.alltag.length; j++) {
                        tagarr[j] = this.alltag[j].id;
                    }

                  
                    var tagarray = tagarr.map(String);
                  
                    const intersection = arr.filter(element => tagarray.includes(element));
                    var inttagarray = intersection.map(Number);

                    var $exampleMulti = $(".select4-tags").select2();
                    $exampleMulti.val(inttagarray).trigger("change");


                    var selectedtag = [];
                    for (var k = 0; k < this.alltag.length; k++) {
                        for (var z = 0; z < this.alltag.length; z++) {


                            if (inttagarray[k] == this.alltag[z].id) {


                                selectedtag[k] = this.alltag[z].name;
                            }
                        }
                    }
                }

                this.selectedtag1 = selectedtag;

              
                this.status = this.blogdata[0]['status']
                this.version = this.blogdata[0]['version']
                //  var v=this.version
                // this.a=parseFloat(Math.round(1.00000000*10^1)/10^1);

                // var a=this.version.toFixed(1)
              
                if (this.version == null) {
                    this.version = 1.0

                }
                if (this.status == 'LIVE' || this.status == 'OFFLINE') {
                    this.version = (this.version + this.versionincrement).toFixed(1)
                    this.blogsave1();

                } else {
                    var data2 = {
                        version: this.version
                    }
                    this.blogpostdetailservice.allimage(data2, this.bid).then(data => {
                        this.blogimage = data

                    })
                }




            }




        });




    }
    resetData() {
        // this.title=""
        // this.category=""
        // this.url=""
        this.selectedtag1 = []

        this.athumbnails = null
        this.sortdescription = null
        $('.summernote').siblings('.note-editor').children('.note-editing-area').children('div.note-editable').html("");
        this.description = ""
        $('.summernote1').siblings('.note-editor').children('.note-editing-area').children('div.note-editable').html("");
        $.notify({
            message: "Deleted Successfully"
        }, {
                type: 'success',
                placement: {
                    from: 'bottom',
                    align: 'right'
                },
                delay: 100,
                timer: 100
            });

    }
    Previewblog(url, version, id) {

      
        var finalurl = (this.blogurl + url + '/' + id + '?version=' + version)
        //   // ['/product/' + name1],{queryParams:{'':btoa(id)}}
        // this.finalurl=(this.url+url,{queryParams:{'Version':version}})
      
        window.open(finalurl, "_blank");

    }
    getalltag() {
        var value = ""
        this.blogtagService.allBlogTag().then(data => {
            if (data) {
                this.alltag = data



            }
        })

    }
    createFormData1(event) {


        var file = <File>event.target.files[0];
        let fr = new FileReader();
        fr.onload = (e: any) => {
            var img = new Image;
            img.src = e.target.result;
            img.onload = () => {
                var width = img.naturalWidth;
                var height = img.naturalHeight;
               
                if (width == 1170 && height == 658) {
                    this.athumbnails1 = <File>event.target.files[0];
                }
                else {

                   
                    alert('Height and Width must  exceed 1170*658 pixels.')
                }
            };
        };
        fr.readAsDataURL(file)

        var type = <File>event.target.files[0].type;
      
    }

    createFormData(event) {

        this.file = <File>event.target.files[0];
        var type = <File>event.target.files[0].type;


        this.imagename = this.file.name.toString()

      
        var data = {
            name: this.imagename,
            version: this.version
        }

        this.blogpostdetailservice.Uploadimage(data, this.file, this.bid).then(data => {

            if (data) {

               
                $.notify({
                    message: "Successfully Added"
                }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                this.blogimage.push(data.data)
            }
            else {

                $.notify({
                    message: "Error in Image Insertion"
                }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
            }

        })

      
    }
    blogsave1() {
        this.sortdescription = $('.summernote').siblings('.note-editor').children('.note-editing-area').children('div.note-editable').html();
        this.description = $('.summernote1').siblings('.note-editor').children('.note-editing-area').children('div.note-editable').html();
        var column1RelArray = [];

        $('.select4-tags').siblings('span.select2-container--default').children('span.selection').children('span.select2-selection').children('ul.select2-selection__rendered').children('li').each(function () {

            column1RelArray.push($(this).attr('title'));
        });

        column1RelArray = column1RelArray.filter(function (element) {
            return element !== undefined;
        });

        var data = {
            title: this.title,
            url: this.url,
            sortdescription: this.sortdescription,
            description: this.description,
            tags: column1RelArray.toString(),
            version: this.version,
            category: this.categoryId,
            status: "SAVEDRAFT",
            articlethumbnails: this.athumbnails

        }
      
        this.blogpostdetailservice.iblogpost1(data, this.banner, this.bid).then(data => {
            this.blogimage = data.image
        })

    }

    blogsave() {
        this.sortdescription = $('.summernote').siblings('.note-editor').children('.note-editing-area').children('div.note-editable').html();
        this.description = $('.summernote1').siblings('.note-editor').children('.note-editing-area').children('div.note-editable').html();
        var column1RelArray = [];

        $('.select4-tags').siblings('span.select2-container--default').children('span.selection').children('span.select2-selection').children('ul.select2-selection__rendered').children('li').each(function () {

            column1RelArray.push($(this).attr('title'));
        });

        column1RelArray = column1RelArray.filter(function (element) {
            return element !== undefined;
        });

        var data = {
            title: this.title,
            url: this.url,
            sortdescription: this.sortdescription,
            description: this.description,
            tags: column1RelArray.toString(),
            version: this.version,
            category: this.categoryId,
            status: "SAVEDRAFT",
            articlethumbnails: this.athumbnails

        }
      
        this.blogpostdetailservice.iblogpost(data, this.athumbnails1, this.bid).then(data => {
           
            if (data.status) {
                $.notify({
                    message: "Blog Saved In Draft"
                }, {
                        type: 'success',
                        placement: {
                            from: 'top',
                            align: 'center'
                        },
                        delay: 100,
                        timer: 100
                    });
            }
            else {
                $.notify({
                    message: "Not Saved"
                }, {
                        type: 'danger',
                        placement: {
                            from: 'top',
                            align: 'center'
                        },
                        delay: 100,
                        timer: 100
                    });
            }

        })

    }
    blogpublish() {
        this.sortdescription = $('.summernote').siblings('.note-editor').children('.note-editing-area').children('div.note-editable').html();
        this.description = $('.summernote1').siblings('.note-editor').children('.note-editing-area').children('div.note-editable').html();
        var column1RelArray = [];

        $('.select4-tags').siblings('span.select2-container--default').children('span.selection').children('span.select2-selection').children('ul.select2-selection__rendered').children('li').each(function () {

            column1RelArray.push($(this).attr('title'));
        });

        column1RelArray = column1RelArray.filter(function (element) {
            return element !== undefined;
        });
        if (this.title == undefined || this.title == "") {

            $.notify({
                message: "Please Enter title."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });

            return;
        }
        if (this.url == undefined || this.url == "") {

            $.notify({
                message: "Please Enter url."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });

            return;
        }

        if (column1RelArray == undefined || column1RelArray == [] || column1RelArray.length == 0) {

            $.notify({
                message: "Please Enter tagitems ."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });

            return;
        }
      

        var data = {
            title: this.title,
            url: this.url,
            sortdescription: this.sortdescription,
            description: this.description,
            tags: column1RelArray.toString(),
            version: this.version,
            category: this.categoryId,
            status: "PENDDING",
            articlethumbnails: this.athumbnails


        }


        this.blogpostdetailservice.iblogpost(data, this.athumbnails1, this.bid).then(data => {

            if (data.status) {
                $.notify({
                    message: "Blog status Pendding"
                }, {
                        type: 'success',
                        placement: {
                            from: 'top',
                            align: 'center'
                        },
                        delay: 100,
                        timer: 100
                    });

                return;
            }
            else {
                $.notify({
                    message: "Error"
                }, {
                        type: 'danger',
                        placement: {
                            from: 'top',
                            align: 'center'
                        },
                        delay: 100,
                        timer: 100
                    });

            }

        })
    }


    updateList(i: number, property: string, event: any) {
        const editField = event.target.textContent;

        this.blogimage[i][property] = editField
       
        this.imagename = this.blogimage[i][property]
    }
    Preview(url) {
        {
            var finalurl = this.imageurl + url
            window.open(finalurl, "_blank");
        }

    }

    deleteimage(image, index) {

        this.imageid = image.id
        //var version=image.version

        var data = {
            version: image.version
        }
        this.index = index



        this.blogpostdetailservice.dblogimage(data, this.imageid).then(data => {


            if (data.status) {

                $.notify({
                    message: "Deleted Successfully"
                }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                this.blogimage.splice(this.index, 1);

            }
            else {


                $.notify({
                    message: "Error in Delete "
                }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });

            }
        })
    }



    updateimagename(i, index) {

        var id = i.id

        var iversion = i.version

      
        var data = {
            imagename: this.imagename,
            version: iversion
        }
        this.blogpostdetailservice.Updateimage(data, id).then(data => {
            if (data.status) {

                $.notify({
                    message: "Updated Successfully"
                }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });

                this.blogimage[index] = data.data
            }
            else {

                $.notify({
                    message: "Error in update"
                }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });



            }
        })
    }
    onRowClick(event, id) {
       
    }
}



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/blogpostdetail/blogpostdetail.page.ts